<template>
	<div class="flex-between">
		<div>
			<div v-if="prev" @click="updateOrderIndex(--orderIndex)">
				<i class="cubeic-back"></i>
				<span v-if="isErrandBuyOrder(prev)">
					{{ prev.store_name }}
				</span>
				<span v-else-if="isErrandSendOrder(prev)"> {{ $t('order_progress.errand_send') }} </span>
			</div>
		</div>
		<div></div>
		<div v-if="next" @click="updateOrderIndex(++orderIndex)">
			<span v-if="isErrandBuyOrder(next)">
				{{ next.store_name }}
			</span>
			<span v-else-if="isErrandSendOrder(next)"> {{ $t('order_progress.errand_send') }} </span>
			<i class="cubeic-arrow"></i>
		</div>
	</div>
</template>

<script>
export default {
	name: 'ErrandOrderSlider',
	props: {
		orderList: {
			type: Array,
			require: true
		},
		currentOrderIndex: {
			type: Number,
			require: true
		}
	},
	data() {
		return {
			orderIndex: this.currentOrderIndex
		}
	},
	watch: {
		currentOrderIndex(val) {
			this.orderIndex = val
		}
	},
	computed: {
		prev: function () {
			return this.orderList[this.currentOrderIndex - 1]
		},
		next: function () {
			return this.orderList[this.currentOrderIndex + 1]
		},
		current: function () {
			return this.orderList[this.currentOrderIndex]
		}
	},
	methods: {
		isErrandBuyOrder(order) {
			return order && !!order.order_id
		},
		isErrandSendOrder(order) {
			return order && !!order.o2o_errand_order_id
		},
		updateOrderIndex(index) {
			this.$emit('updateOrderIndex', index)
			console.log('update order index', index)
		}
	}
}
</script>

<style lang='scss'scoped>
$foldBgColor: #f4c41e;
$toggleTabColor: white;
$toggleBorder: #898989;

.flex-between {
	display: flex;
	justify-content: space-between;
}
</style>
